<section class="galeria-aviso" *ngIf="imagens?.length" aria-label="Imagens do aviso">
  <p class="galeria-aviso__dica">Clique na imagem para ampliar</p>
  <div class="galeria-aviso__miniaturas">
    <button #miniatura type="button" *ngFor="let imagem of imagens; let i = index"
      class="galeria-aviso__miniatura" (click)="abra(i, miniatura)"
      [attr.aria-label]="'Ampliar imagem ' + (i + 1) + ' do aviso'">
      <img [src]="'/images/empresa/' + imagem.linkImagem" [alt]="'Imagem ' + (i + 1) + ' do aviso'" loading="lazy">
      <i class="fas fa-search-plus" aria-hidden="true"></i>
    </button>
  </div>
</section>

<kendo-dialog *ngIf="indice !== null && imagens?.length" class="galeria-aviso-zoom"
  title="Imagem {{indice + 1}} de {{imagens.length}}" width="min(950px, 95vw)"
  [minWidth]="0" (close)="feche()" (keydown)="tecla($event)">
  <div class="galeria-aviso__ampliada" (touchstart)="inicieToque($event)" (touchend)="termineToque($event)">
    <img [src]="'/images/empresa/' + imagens[indice].linkImagem" [alt]="'Imagem ' + (indice + 1) + ' do aviso'">
  </div>
  <kendo-dialog-actions>
    <button type="button" class="btn btn-outline-secondary" *ngIf="imagens.length > 1" (click)="navegue(-1)" aria-label="Imagem anterior">Anterior</button>
    <button type="button" class="btn btn-outline-secondary" *ngIf="imagens.length > 1" (click)="navegue(1)" aria-label="Próxima imagem">Próxima</button>
    <button type="button" class="btn btn-primary" (click)="feche()">Fechar imagem</button>
  </kendo-dialog-actions>
</kendo-dialog>
